/**
 * @generated SignedSource<<4461d2b84ef7278ce97a18756cff0948>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountPasswordPageMutation$variables = {
  current: string;
  new: string;
};
export type AccountPasswordPageMutation$data = {
  readonly changePassword: boolean | null;
};
export type AccountPasswordPageMutation = {
  response: AccountPasswordPageMutation$data;
  variables: AccountPasswordPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "current"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "new"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "current",
        "variableName": "current"
      },
      {
        "kind": "Variable",
        "name": "new",
        "variableName": "new"
      }
    ],
    "kind": "ScalarField",
    "name": "changePassword",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountPasswordPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AccountPasswordPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "564c4fddb675142ae0db601a8bc5d3ff",
    "id": null,
    "metadata": {},
    "name": "AccountPasswordPageMutation",
    "operationKind": "mutation",
    "text": "mutation AccountPasswordPageMutation(\n  $current: String!\n  $new: String!\n) {\n  changePassword(current: $current, new: $new)\n}\n"
  }
};
})();

(node as any).hash = "1733f7c8fddd2510abebb7622f1858fe";

export default node;
